<script>
  import { onMount } from "svelte"
  import { loadJs } from "../../Script/loadLibrary"

  export let screenGradient

  onMount(async () => {
    await loadJs("particlesJS", "assets/lib/particles.min.js")
    particlesJS.load("particles-js", "assets/particles.json", function () {})
  })
</script>

<div class="min-h-full w-full" style="background: {screenGradient};" id="particles-js" />
